import { Container, Col } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import Link from "next/link";
import { isMobile } from "react-device-detect";
import Skeleton from "react-loading-skeleton";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { setLoader } from "../../redux/actions/globalAction";
import Image from "next/image";
import { fetchJourneyCategories } from "../../actions/homePage";
import LazyLoad from 'react-lazyload';

const Services = ({ apiData, globalData, setLoader, cart }) => {
  const [data, setData] = useState(null);
  const [show, setShow] = useState(false)
  const dispatch = useDispatch();
  const [slidesToShow, setSlidesToShow] = useState(8);

  useEffect(() => {
    setData(apiData.categories);
  }, [apiData.categories]);

  useEffect(() => {
    dispatch(fetchJourneyCategories())
  }, []);

  const CustomNextButton = ({ onClick }) => {
    const handleClick = () => {
      // setShow(true)
      setSlidesToShow(data.length)
      onClick();
    }
    return <button className="slick-next slick-arrow" onClick={handleClick} />
  };

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    initialSlide: 0,
    lazyload: true,
    // nextArrow: <CustomNextButton />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  };

  return (
    <div className="service-items pb-0">
      <Container fluid>
        <h5 className="mb-0">What are you looking for?</h5>
        {data ? (
          <Col xs={12} className="service-container">
            <Slider {...settings}>
              {data != "" &&
                data.map((single, index) => {
                  return (
                    <LazyLoad key={index}>
                      <div className="item" key={index}>
                        <div className="categories-box">
                          {/* {cart.workshop ? (
                          <a
                            onClick={() => {
                              setShowWarning(true);
                              localStorage.setItem('selected-service',single.Slug)
                              setRedirectURL(
                                `/services/${
                                  globalData.locationData?.data
                                    ?.EmirateAreaSlug || "dubai"
                                }/${single.Slug}`
                              );
                            }}
                          >
                            <div
                              className="service-buttons"
                              style={{
                                textDecoration: "none",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "10px",
                                height: 140,
                              }}
                            >
                              <div
                                style={{
                                  height: "40px",
                                  width: "60px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  className="service-image"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    position: "relative",
                                  }}
                                >
                                  <Image
                                    src={single.ImgUrl}
                                    alt="Service Category"
                                    layout="fill"
                                    objectFit="contain"
                                  />
                                </div>
                              </div>
                              <span
                                className="service-name"
                                style={{
                                  fontSize: 14,
                                  fontWeight: "400",
                                  textAlign: "center",
                                  padding: "7px",
                                }}
                              >
                                {single.Name}
                              </span>
                            </div>
                          </a>
                        ) : ( */}
                          <Link
                            href={`/services/${globalData.locationData?.data?.EmirateAreaSlug ||
                              "dubai"
                              }/${single.Slug}`}
                          >
                            <a onClick={() => {
                              setLoader(true)
                              localStorage.setItem('selected-service', single.Slug)
                              localStorage.setItem("selected-service-title", single.Name)
                            }}>
                              <div
                                className="service-buttons"
                                style={{
                                  textDecoration: "none",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  padding: "10px",
                                  height: 140,
                                }}
                              >
                                <div
                                  style={{
                                    height: "40px",
                                    width: "60px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    className="service-image"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      position: "relative",
                                    }}
                                  >
                                    <Image
                                      src={single.ImgUrl}
                                      alt="Service Category"
                                      layout="fill"
                                      objectFit="contain"
                                    />
                                  </div>
                                </div>
                                <span
                                  className="service-name"
                                  style={{
                                    fontSize: 14,
                                    fontWeight: "400",
                                    textAlign: "center",
                                    padding: "7px",
                                  }}
                                >
                                  {single.Name}
                                </span>
                              </div>
                            </a>
                          </Link>
                          {/* )} */}
                        </div>
                      </div>
                    </LazyLoad>
                  );
                })}
            </Slider>
          </Col>
        ) : isMobile ? (
          <Col
            lg={12}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Skeleton style={{ width: "100%", height: "70px" }} />
            <Skeleton style={{ width: "100%" }} />
          </Col>
        ) : (
          <Col
            lg={12}
          // style={{
          //   display: "flex",
          //   flexDirection: "row",
          //   justifyContent: "space-between",
          //   alignItems: "center",
          // }}
          >
            {/* Test Area */}
            <Skeleton style={{ width: "100%", height: "80px" }} />
            <Skeleton style={{ width: "100%", height: "10px" }} />
          </Col>
        )}
      </Container>
      {/* <ConfirmCartChange
        show={showWarning}
        onHide={() => setShowWarning(false)}
        redirectURL={redirectURL}
      /> */}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    cart: state.cart,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setLoader: (flag) => {
      dispatch(setLoader(flag));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Services);
